<template>
  <div>
    <StellaImage
      class="h-full w-full object-cover"
      v-if="designer.imageUrl && isValidImage"
      :src="designer.imageUrl"
      @error="isValidImage = false"
    />
    <StellaText
      v-else
      type="Label S"
      class="flex h-full w-full rounded-full shrink-0 items-center justify-center uppercase"
      :class="bgClass"
    >
      {{ initials }}
    </StellaText>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { type CurrentDesigner } from '/@/data/designer/types'

const { designer, bgClass } = defineProps<{
  designer: Pick<CurrentDesigner, 'firstName' | 'lastName' | 'imageUrl'>
  bgClass?: string | string[]
}>()

const isValidImage = ref(true)
const initials = computed(() => {
  const first = designer.firstName
  const last = designer.lastName
  return `${first.length > 0 ? first[0] : ''}${last.length > 0 ? last[0] : ''}`
})
</script>

<style lang="scss" scoped></style>
